import React, { useMemo, useState, useEffect, useRef, useCallback } from 'react'

//* Components
import Page from 'components/common/Page'
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import FancyButton from 'components/common/FancyButton'
import AnimationWrap from 'components/common/AnimationWrap'
import NewsItem from 'components/pages/NewsItem'

//* Style
import NewsStyle from 'styles/pages/news'

//* HOC's
import { withDataContext, withUIContext } from 'context'

//* Api
import { api } from 'helpers'

//* Helpers
import { slideDown } from 'helpers/_gsapFunctions'

const News = ({ pages, pageParams, selectedLang, winWidth }) => {
	const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, pageParams, selectedLang])

	//! Refs
	const items = useRef([])
	const titleRef = useRef()

	//! States
	const [newsItems, setNewsItems] = useState(null)
	const [hasMore, setHasMore] = useState(null)
	const [secObj, setSecObj] = useState()

	const storeNews = useMemo(() => {
		return newsItems?.map((element, index) => <NewsItem itemData={element} key={index} />)
	}, [newsItems])

	const loadMore = () => {
		return api.get('posts', 'en', { offset: newsItems.length }).then((res) => {
			setNewsItems([...newsItems, ...res.posts])
			setHasMore(res.hasMore)
		})
	}

	useEffect(() => {
		setNewsItems(pageData?.posts)
		setHasMore(pageData?.hasMore)
	}, [pageData])

	useEffect(() => {
		if (items?.current) {
			setSecObj([items.current])
		}
	}, [items, winWidth])

	const startAnimeArr = useCallback((x) => {
		if (x) {
			//! slideDown(item, stagger, delay)
			slideDown([titleRef.current])
		}
	}, [])

	return (
		<NewsStyle>
			<AnimationWrap state={secObj} startAnimeArr={startAnimeArr}>
				<Page>
					<Container ref={items}>
						<div className='overflowHidden title'>
							<Text tag={'h3'} className={`terminaBold translate-100`} text='news' ref={titleRef} />
						</div>
						<div>{storeNews}</div>
						{hasMore && <FancyButton onClick={loadMore} type='long' content='loadMore' />}
					</Container>
				</Page>
			</AnimationWrap>
		</NewsStyle>
	)
}

export default withUIContext(withDataContext(News, ['pages']), ['winWidth'])
